const BISMILLAH_ON = { enabled: true, position: "haut" };
const VERSE = { quote: "« Et nous vous avons créés par paires »", reference: "S78, V8" };

export const PRODUCTS = [
  {
    id: "meriem-fares",
    name: "Mériem & Farès",
    category: "Mariage",
    description: "Bismillah calligraphiée, prénoms et date avec une seule photo du couple en noir et blanc.",
    images: ["/modeles/meriem-fares.jpg"],
    templateId: "bismillah-duo",
    preset: { photoCount: 1, photoMode: "bw", layoutId: "photos-bas", bismillah: BISMILLAH_ON, texts: { names: "Mériem & Farès", number: "12.09.2026", quote: "", reference: "" } },
  },
  {
    id: "sheerine-jonathan",
    name: "Sheerine & Jonathan",
    category: "Mariage",
    description: "Bismillah, prénoms, date et verset, avec les deux photos d'enfance réunies en couleur.",
    images: ["/modeles/sheerine-jonathan.jpg"],
    templateId: "bismillah-duo",
    preset: { photoCount: 2, photoMode: "color", layoutId: "photos-bas", bismillah: BISMILLAH_ON, texts: { names: "Sheerine & Jonathan", number: "24.09.2026", ...VERSE } },
  },
  {
    id: "lina-islem",
    name: "Lina & Islem",
    category: "Mariage",
    description: "La composition intemporelle : Bismillah, prénoms, date, verset et deux photos en couleur.",
    images: ["/modeles/lina-islem.jpg"],
    templateId: "bismillah-duo",
    preset: { photoCount: 2, photoMode: "color", layoutId: "photos-bas", bismillah: BISMILLAH_ON, texts: { names: "Lina & Islem", number: "14.11.2026", ...VERSE } },
  },
  {
    id: "lorynda-slimane",
    name: "Lorynda & Slimane",
    category: "Mariage",
    description: "« Deux enfants, deux chemins… un seul destin » : bienvenue au mariage, prénoms, date et deux photos noir et blanc.",
    images: ["/modeles/lorynda-slimane.jpg"],
    templateId: "bismillah-duo",
    preset: {
      photoCount: 2, photoMode: "bw", layoutId: "photos-bas", bismillah: { enabled: false },
      texts: { intro: "Deux enfants, deux chemins… un seul destin", welcome: "BIENVENUE AU MARIAGE", names: "Lorynda & Slimane", number: "06.06.2026", quote: "", reference: "" },
    },
  },
  {
    id: "safyr-myriam",
    name: "Safyr & Myriam",
    category: "Fiançailles",
    description: "Phrase d'accueil calligraphiée, prénoms, citation sur le bonheur et deux photos noir et blanc.",
    images: ["/modeles/safyr-myriam.jpg"],
    templateId: "fiancailles",
    preset: { photoCount: 2, photoMode: "bw", texts: { names: "Safyr & Myriam" } },
  },
];

export const getProduct = (id) => PRODUCTS.find((p) => p.id === id);

export const applyPreset = (cfg, preset = {}) => ({
  ...cfg,
  ...(preset.photoCount && { photoCount: preset.photoCount }),
  ...(preset.photoMode && { photoMode: preset.photoMode }),
  ...(preset.layoutId && { layoutId: preset.layoutId }),
  texts: { ...cfg.texts, ...preset.texts },
  fonts: { ...cfg.fonts, ...preset.fonts },
  bismillah: { ...cfg.bismillah, ...preset.bismillah },
});
